"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _FormTouristsPicker = require("./FormTouristsPicker");

var _default = _FormTouristsPicker.FormTouristsPicker;
exports["default"] = _default;